// src/utilities/slot.ts
function hasSlot(el, name, tagName) {
  if (name) {
    const slotEelement = el.querySelector(`:scope > [slot="${name}"]`);
    if (slotEelement !== null) {
      if (tagName) {
        return slotEelement.tagName.toUpperCase() === tagName.toUpperCase();
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  const elementChildNodes = getChildElements(el);
  return [...elementChildNodes].some((node) => {
    if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") {
      return true;
    }
    if (node.nodeType === node.ELEMENT_NODE) {
      const el2 = node;
      if (!el2.hasAttribute("slot")) {
        return true;
      }
    }
    return false;
  });
}
function hasSlotWithSpecificElements(el, tagNames, slotName, numberOfElements) {
  const elementChildNodes = getChildElements(el);
  const childElements = elementChildNodes.filter((node) => {
    const el2 = node;
    return node.nodeType === node.ELEMENT_NODE && isElementOfSlot(el2, slotName);
  });
  if (childElements.length <= 0 || numberOfElements && childElements.length !== numberOfElements)
    return false;
  return childElements.every((node) => tagNames.includes(node.nodeName.toLowerCase()));
}
function hasTextDefaultSlot(el, otherAllowedSlots = []) {
  const elementChildNodes = getChildElements(el);
  return el.innerHTML.trim() !== "" && elementChildNodes.every((node) => [Node.TEXT_NODE, Node.COMMENT_NODE].includes(node.nodeType) || otherAllowedSlots.includes(node.getAttribute("slot") || ""));
}
function getInnerText(el) {
  const elementChildNodes = getChildElements(el);
  if (!el.innerHTML.trim()) {
    return "";
  }
  return elementChildNodes.map((node) => {
    var _a;
    if ([Node.TEXT_NODE].includes(node.nodeType)) {
      return (_a = node.nodeValue) == null ? void 0 : _a.trim();
    }
    return "";
  }).join(" ") || "";
}
function getChildElements(el) {
  return convertNodeListToElements(el.childNodes);
}
function getChildElementsByTagName(el, tagName) {
  return getChildElements(el).filter((child) => child.tagName && child.tagName.toLowerCase() === tagName);
}
function convertNodeListToElements(childNodes) {
  const elements = [];
  childNodes.forEach((childNode) => {
    elements.push(childNode);
  });
  return elements;
}
function isElementOfSlot(el, slotName) {
  return !slotName && !el.hasAttribute("slot") || slotName !== void 0 && el.getAttribute("slot") === slotName;
}

export {
  hasSlot,
  hasSlotWithSpecificElements,
  hasTextDefaultSlot,
  getInnerText,
  getChildElementsByTagName
};
